import React, { useState } from "react";
import { BtnBox, Wrapper } from "./style";
import CreateWallet from "./CreateWallet";
import RecoveryWallet from "./RecoveryWallet";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
const Com2 = () => {
  const [isSelectedFirst, setIsSelectedFirst] = useState(true);
  const selectHandler = (selectedFirst) => {
    setIsSelectedFirst(selectedFirst);
  };
  const { t } = useTranslation("usingWallet");
  const language = useSelector(selectLanguage);
  return (
    <Wrapper>
      <BtnBox isActive={isSelectedFirst} language={language}>
        <div onClick={() => selectHandler(true)}>{t("2-1")}</div>
        <div onClick={() => selectHandler(false)}>{t("2-2")}</div>
      </BtnBox>
      {isSelectedFirst ? <CreateWallet /> : <RecoveryWallet />}
    </Wrapper>
  );
};

export default Com2;
